import { croppedCanvas } from './TilesetService'

type ImageOptions = {
  width: number
  height: number
  quality?: number
}

export default class Image {
  width: number
  height: number
  quality?: number

  image?: OffscreenCanvas

  constructor(options: ImageOptions) {
    this.width = options.width
    this.height = options.height
    this.quality = options.quality || 100

    this.image = new OffscreenCanvas(Math.floor(options.width), Math.floor(options.height))
  }

  /**
   * Prepare all tiles to fit the baselayer
   */
  prepareTileParts(tile: { image: OffscreenCanvas; box: number[] }) {
    const { image } = tile

    return new Promise(resolve => {
      const metadata = { width: image.width, height: image.height }

      const x = tile.box[0]
      const y = tile.box[1]
      const sx = x < 0 ? 0 : x
      const sy = y < 0 ? 0 : y
      const dx = x < 0 ? -x : 0
      const dy = y < 0 ? -y : 0
      const extraWidth = x + (metadata.width - this.width)
      const extraHeight = y + (metadata.width - this.height)
      const w = metadata.width + (x < 0 ? x : 0) - (extraWidth > 0 ? extraWidth : 0)
      const h = metadata.height + (y < 0 ? y : 0) - (extraHeight > 0 ? extraHeight : 0)

      if (!w || !h) {
        resolve({ success: false })
        return null
      }

      try {
        const cropped = croppedCanvas(image, [dx, dy, dx + w, dy + h])

        resolve({
          success: true,
          position: { top: Math.round(sy), left: Math.round(sx) },
          image: cropped,
        })
      } catch (e) {
        resolve({ success: false })
      }
    })
  }

  async draw(tiles: Array<{ image: any; box: number[] }>) {
    const tileParts: any[] = []
    tiles.forEach((tile: { image: any; box: number[] }) => {
      tileParts.push(this.prepareTileParts(tile))
    })

    const results = await Promise.all(tileParts)

    const preparedTiles = results.filter(v => v.success)

    const ctx = this.image?.getContext('2d')
    if (!ctx) return

    ctx.imageSmoothingEnabled = false

    for (const tile of preparedTiles) {
      ctx.drawImage(tile.image, Math.round(tile.position.left), Math.round(tile.position.top))
    }

    return true
  }
}
